import React, { Component } from 'react';
import * as E from './styles';
import JLoading from '../JLoading';

// Image link SVG inline
const ImageLinkIcon = '/assets/images/image-link.svg';

// Generate a stable unique ID for each image preview
const generateImageId = (fileName) => `${fileName}-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;

export default class JChatForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyText: '',
      previewImages: [],
      uploading: false
    };
    this.imgRef = React.createRef();
    this._handlePickerImage = this._handlePickerImage.bind(this);
  }

  componentDidMount() {
    this.setState({ uploading: this.props.uploading });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uploading !== this.props.uploading) {
      this.setState({ uploading: this.props.uploading });
    }
  }

  _handlePickerImage() {
    this.imgRef.current.click();
  }

  _handleSelectedImage = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      Promise.allSettled(files.map((file, index) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.addEventListener('load', (ev) => {
            resolve({ index, image: ev.target.result, file });
          });
          reader.addEventListener('error', () => {
            reject(new Error(`Failed to load file: ${file.name}`));
          });
          reader.readAsDataURL(file);
        });
      })).then(results => {
        const successful = results
          .filter(result => result.status === 'fulfilled')
          .map(result => result.value);
        const failed = results.filter(result => result.status === 'rejected');

        if (failed.length > 0) {
          const errorMessages = failed.map(f => f.reason?.message || 'Unknown error').join(', ');
          // Optionally notify user about failed uploads
          if (this.props?.onUploadError) {
            this.props.onUploadError(`Failed to load ${failed.length} file(s): ${errorMessages}`);
          }
        }

        if (successful.length > 0) {
          const newImages = successful.map(s => ({
            id: generateImageId(s.file.name),
            src: s.image,
          }));
          this.setState(prevState => ({
            previewImages: [...prevState.previewImages, ...newImages],
          }));

          const newFiles = successful.map(s => {
            const { file } = s;
            const blob = file.slice(0, file.size, file.type);
            const newFileName = file.name.replace(/\s/g, '');
            return new File([blob], newFileName, { type: file.type });
          });
          this.props?.handleUploadFile?.(newFiles);
        }

        // Reset file input to allow selecting the same file again
        if (this.imgRef.current) {
          this.imgRef.current.value = '';
        }
      }).catch(error => {
        if (this.props?.onUploadError) {
          this.props.onUploadError('An unexpected error occurred while uploading files.');
        }
        // Reset file input even on error
        if (this.imgRef.current) {
          this.imgRef.current.value = '';
        }
      });
    }
  };

  _removeImagePreview = (id, index) => {
    this.setState((prevState) => ({
      previewImages: prevState.previewImages.filter((img) => img.id !== id),
    }));
    this.props?.handleRemoveUploadFile?.(index);
  };

  _handleChangeText = (e) => {
    this.setState({ bodyText: e.target.value });
  };

  _handleSubmitForm = () => {
    const { handleSubmit } = this.props;
    // Guard against submitting while uploads are in progress
    const isUploading = this.state.uploading ||
      this.state.previewImages.some(img =>
        img.uploading ||
        img.status === 'uploading' ||
        (typeof img.progress === 'number' && img.progress < 100)
      );
    if (isUploading) return false;
    if (!this.state.bodyText && !this.state.previewImages.length) return false;
    handleSubmit?.(this.state.bodyText);
    this.setState({ bodyText: '', previewImages: [] });
  };

  render() {
    const { handleSendLink } = this.props;
    const { previewImages, uploading } = this.state;

    return (
      <E.Container>
        {!!previewImages.length && (
          <E.ImageContainer>
            {previewImages.map((image, index) => (
              <E.ImagePreviews key={image.id}>
                <E.CloseImage onClick={() => this._removeImagePreview(image.id, index)}>x</E.CloseImage>
                <E.ImagePreview src={image.src} />
                {this.state.uploading && (
                  <E.LoadingContainer>
                    <JLoading />
                  </E.LoadingContainer>
                )}
              </E.ImagePreviews>
            ))}
          </E.ImageContainer>
        )}
        <E.FormChat>
          <E.ImagePicker type={`image`} src={`/assets/images/image-picker.png`} onClick={this._handlePickerImage} />
          {handleSendLink && <E.ImageLink type={`image`} src={ImageLinkIcon} onClick={handleSendLink} />}
          <input type={`file`} multiple accept="image/jpeg, image/png" ref={this.imgRef} style={{ display: 'none' }} onChange={this._handleSelectedImage} />
          <E.TextInput
            value={this.state.bodyText}
            type={`text`}
            placeholder={`Type your message here …`}
            onKeyDown={event => event.key === 'Enter' && this._handleSubmitForm()}
            onChange={this._handleChangeText}
          />
          <E.SubmitButton disabled={this.state.uploading} onClick={() => this._handleSubmitForm()}>{`SEND`}</E.SubmitButton>
        </E.FormChat>
      </E.Container>
    );
  }
}

